import React from 'react'
import {useTranslation} from '@modifi/plugin-i18n'

type DocumentTypeLabelForStupidInconsistencyProps = {
  children: string
}

const DocumentTypeLabelForStupidInconsistency: React.FC<
  DocumentTypeLabelForStupidInconsistencyProps
> = ({children}) => {
  const {t} = useTranslation('shared')
  // yes we want to use documentType instead of document-type :(
  return <>{t(`documentType.${children}`)}</>
}

export default DocumentTypeLabelForStupidInconsistency
